<template>
    <v-app-bar
      app
      extension-height="80"
      elevation="0"
      min-height="80"
      color="white"
      style="z-index: 20"
      v-if="!['login'].includes(this.$route.name)"
    >
      <v-toolbar-title class="mt-9">
        <div class="ml-10 d-flex">
          <v-btn v-if="!isDashboard" icon depressed class="mr-3 mt-4 pa-0" height="26" max-width="26" color="#51A7F8" @click="goTo('/dashboard')">
            <v-icon large color="#51A7F8">
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <div>
            <p class="font-weight-bold titleText--text text-capitalize mb-0">
             
              <span >{{projectName}}</span>
            </p>
            <span v-if="!isDashboard && !scope.status" class="font-weight-bold titleText--text text-capitalize" style="font-size: 14px; opacity: 0.4; margin-top: -10%">
            {{scope.country}}  <v-icon style="margin-top: -3px">mdi-circle-small</v-icon>  {{scope.level}}  <v-icon style="margin-top:-3px">mdi-circle-small</v-icon> {{scope.brand}}  <v-icon style="margin-top: -3px">mdi-circle-small</v-icon> {{formattedTimePeriod(scope.start_date, false)}} - {{formattedTimePeriod(scope.end_date, false)}}
          </span>
          <span v-else class="font-weight-bold titleText--text text-capitalize" style="font-size: 14px; opacity: 0.4; margin-top: -10%"></span>
          </div>
        </div>
        <div>
          <v-btn
            v-if="breakpointIsMobile"
            icon
            small
            class="mr-3"
            @click="toggleMenu"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="d-flex align-center mt-6 pl-5 pr-2 py-2 rounded mr-6"
            style="background: #F3F5F8"
            @click="menuOpen = !menuOpen"
          >
            <span class="mr-5 text-capitalize titleText--text font-weight-black text-body-2">{{ loginusername }}</span>
            <v-icon color="#505D6F" v-if="!menuOpen">mdi-chevron-down</v-icon>
            <v-icon color="#505D6F" v-else>mdi-chevron-up</v-icon>
          </div>
        </template>
        <v-list dense>
          <v-list-item @click="goTo('/logout')">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </template>

  <script>
  import globalval from "../../global/globalvar";
  import apifactory from "../../apis/apifactory";
  import API from '../../modules/UploadData/api'
//   import { useGlobalStore } from '../../store/global';
//   import { useModelOutcomeStore } from '../../store/modelOutcome';

  //import { mapState } from "vuex";
  import GlobalStrorage from "../../global/GlobalStrorage";

  export default {
    components: {},
    props: {
      title: {
        type: String,
        default: "",
      },
      fordashboard: {
        type: Number,
        default: 0,
      },
    },
    // setup () {
    //   const modelOutcomeStore = useModelOutcomeStore()
    //   const globalStore = useGlobalStore()

    //   return { modelOutcomeStore, globalStore }
    // },
    data: () => ({
      valIsfordashboard: false,
      countername: null,
      selectedprojectidname: null,
      selectedprojectidnametest: null,
      drawer: true,
      appname: globalval.appname,
      project: null,
      userid: 0,
      msg: "",
      scope: null,
      appItems: [],
      menuOpen: false,
      links: [
        {
          icon: "mdi-clock",
          text: "Dashboard",
          route: "/dashboard",
        },
      ],
      months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
    }),
    methods: {
      formattedTimePeriod(period, splitted) {
            let periodDate = new Date(period)

            if (splitted && period) {
                let timePeriod = period.split(' - ')
                let timePeriod1 = new Date(timePeriod[0])
                let timePeriod2 = new Date(timePeriod[1])

                return `${this.months[timePeriod1.getMonth()]} ${timePeriod1.getDate()}, ${timePeriod1.getFullYear()} - ${this.months[timePeriod2.getMonth()]} ${timePeriod2.getDate()}, ${timePeriod2.getFullYear()}`
            }

            return `${this.months[periodDate.getMonth()]} ${periodDate.getDate()}, ${periodDate.getFullYear()}`
          },
      gotoHome() {
        let newurl =
          globalval.PARAM_GLOBAL_HOME + GlobalStrorage.getloginuserid();
        window.location.href = newurl;
      },
      goTo(url) {
        return this.$router.push(url);
      },
      openurl(url, app_id) {
        // let newurl="http://localhost:8081/#/ExtraAuth" +url;
        // eslint-disable-next-line no-unused-vars
        let appid = app_id;
        let newurl = url;
        window.location.href = newurl;
      },
      getloginuserapp() {
        apifactory
          .getloginuserapps(this.userid)
          .then((res) => {
            // alert(res.status);

            if (res.status != 200) {
              alert(res.data.message);
            } else {
              this.appItems = res.data;
            }
          })
          .catch(function (error) {
            console.warn(error);
          });
      },
      getproject() {
        this.selectedprojectidname = this.title;
      },
    },
    computed: {
      userid() {
        return localStorage.getItem("SET_USERID");
      },
      loginusername() {
        return localStorage.getItem("SET_USERNAME");
      },
      projectName() {
        return localStorage.getItem("SET_PROJECTNAME");
      },
      getprojectcountry() {
        let tempdata = [];
        tempdata = JSON.stringify(
          localStorage.getItem("SET_PROJECTDATA")
        ).country;
        console.log('project', tempdata)
        return tempdata; //localStorage.getItem('SET_PROJECTDATA')[0].country;
      },
      breakpointIsMobile() {
        return ["xs"].includes(this.$vuetify.breakpoint.name);
      },
      isDashboard () {
        return this.$route.name === 'dashboard'
      },
    },
    mounted() {
      // alert('navmount');
      this.userid = localStorage.getItem("SET_USERID");
      this.loginusername = localStorage.getItem("SET_USERNAME");
      this.getloginuserapp();
      this.selectedprojectidname = localStorage.getItem("SET_PROJECTNAME");
      this.valIsfordashboard = this.fordashboard;


      this.project = JSON.parse(localStorage.getItem('project'))
      this.getloginuserapp();
      // const projectId = localStorage.getItem('SET_PROPJECTID')
      API
        .gettheParameterByProjectStep().then(res => this.scope = res.data)
    },
    watch: {
      scope (v) {
        console.log(v)
      }
    }
  };
  </script>
  <style scoped>
  .margin-appname {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .margin-icon {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
  .v-divider-new {
    border-color: rgba(247, 247, 247, 0.12) !important;
    width: 2% !important;
  }

  .cursor__pointer {
    cursor: pointer;
  }

  div.btn__content {
    padding: 0 !important;
  }
  </style>

